import { oc } from '@orpc/contract'
import { z } from 'zod'

export const activityEventSchema = z.object({
  id: z.string(),
  type: z.enum(['chat', 'document', 'whiteboard']),
  title: z.string(),
  /** ISO timestamp — used for calendar placement */
  timestamp: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
})

export const activityListContract = oc
  .input(
    z.object({
      projectId: z.string().min(1),
      from: z.string(),
      to: z.string(),
    })
  )
  .output(
    z.object({
      items: z.array(activityEventSchema),
    })
  )
